<div class="bls-accordion">
  <header
    (click)="onToggle()"
    class="bls-accordion-header"
    [ngClass]="{ 'is-expanded-h': expanded }"
    [attr.aria-expanded]="expanded"
  >
    <ng-content select="[slot=header]"></ng-content>
  </header>
  <div
    [@toggle]="expanded"
    class="bls-accordion-content"
    [ngClass]="{ 'is-expanded': expanded }"
  >
    <ng-content select="[slot=content]"></ng-content>
  </div>
</div>
